/**
 * Services Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { AsyncManageServiceNamesComponent } from "../../components/AsyncComponent/AsyncComponent";

// async components

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageServiceNamesComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
